import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    CardGridEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem2,
    GridItem4,
    GridItem4xs6,
    GridItem6,
    GridItem6sm12xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import { 
    TextValidatorText,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import { 
    AutocompletePadrao,
} from '../../../business-components/Autocomplete/Autocomplete'

import grauInstrucaoList from '../../../business-rules/List/grauInstrucaoList'

import profissaoList from '../../../business-rules/List/profissaoList'

import {
    processaAlteracaoConjugeProfissaoConjuge
} from './CadastroServiceConjuge'

import {
    CardGridDivHeaderEntradaDadosConjuge,
    NomeConjuge,
    NascimentoConjuge,
    IdadeConjuge,
    SexoConjuge,
    NomeCurtoConjuge,
    CpfConjuge,
    ContatoConjuge,
    ContaInvestimentosConjuge,
    AvatarConjuge
} from './CadastroCompConjuge'



const CadastroFormConjuge = ({ values, handleChange, setFieldValue }) => {
    return (
        <GridItem6sm12xs12>
            <CardGridEntradaDados>
                <CardGridDivHeaderEntradaDadosConjuge
                    values={values}
                />

                <CardGridDivBodyEntradaDados>
                    <GridContainer>
                        <GridItem12>
                            <NomeConjuge
                                values={values}
                                handleChange={handleChange}
                            />
                        </GridItem12>
                    </GridContainer>

                    <GridContainer>
                        <GridItem4xs6>
                            <NascimentoConjuge
                                values={values}
                                setFieldValue={setFieldValue}
                            />
                        </GridItem4xs6>
                        <GridItem2>
                            <IdadeConjuge
                                values={values}
                                handleChange={handleChange}
                            />
                        </GridItem2>
                        <GridItem4>
                            <SexoConjuge
                                values={values}
                                handleChange={handleChange}
                            />
                        </GridItem4>
                    </GridContainer>

                    <GridContainer>
                        <GridItem6>
                            <NomeCurtoConjuge
                                values={values}
                                handleChange={handleChange}
                            />
                        </GridItem6>
                        <GridItem6> 
                            <CpfConjuge
                                values={values}
                                handleChange={handleChange}
                            />
                        </GridItem6>
                    </GridContainer>

                    <CardGridDividerElementos/>
                    
                    <GridContainer>
                        <GridItem6>
                            <TextFieldTextSelect
                                name="grauInstrucaoConjuge"
                                label={LABEL.grauInstrucao}
                                value={values.grauInstrucaoConjuge || ''}
                                onChange={handleChange}
                                list={grauInstrucaoList}
                            />
                        </GridItem6>
                        <GridItem6>
                            <TextValidatorText
                                name="formacaoConjuge"
                                label={LABEL.formacao}
                                value={values.formacaoConjuge || ''}
                                onChange={handleChange}
                                tamMax={TAMMAX.formacao}
                            />
                        </GridItem6>
                    </GridContainer>
                    
                    <GridContainer>
                        <GridItem6>
                            <AutocompletePadrao
                                name="profissaoConjuge"
                                label={LABEL.profissao}
                                value={values.profissaoConjuge || ''}
                                handleChange={handleChange}
                                list={profissaoList}
                                onBlur={processaAlteracaoConjugeProfissaoConjuge(values)}
                            />
                        </GridItem6>

                        <GridItem6>
                            <TextValidatorText
                                name="empresaConjuge"
                                label={LABEL.empresa}
                                value={values.empresaConjuge || ''}
                                onChange={handleChange}
                                tamMax={TAMMAX.empresa}
                            />
                        </GridItem6>
                    
                        {(values.profissaoConjuge === HARDCODE.profissaoOutras ||
                        (values.profissaoConjuge && values.profissaoConjuge.indexOf(HARDCODE.profissaoOutrasFuncionarioPublico) !== -1)) && (
                            <GridItem6>
                                <TextValidatorText
                                    name="profissaoConjugeOutras"
                                    label={LABEL.profissaoOutras}
                                    value={values.profissaoConjugeOutras || ''}
                                    onChange={handleChange}
                                    tamMax={TAMMAX.profissaoOutras}
                                />
                            </GridItem6>
                        )}

                        <GridItem6>
                            <TextValidatorText
                                name="ocupacaoConjuge"
                                label={LABEL.ocupacao}
                                value={values.ocupacaoConjuge || ''}
                                onChange={handleChange}
                                tamMax={TAMMAX.ocupacao}
                            />
                        </GridItem6>
                    </GridContainer>
                    
                    <CardGridDividerElementos/>

                    <ContatoConjuge
                        values={values}
                        handleChange={handleChange}
                    />

                    <ContaInvestimentosConjuge
                        values={values}
                        handleChange={handleChange}
                    />

                    <CardGridDividerElementos/>

                    <AvatarConjuge
                        values={values}
                        setFieldValue={setFieldValue}
                    />    
                </CardGridDivBodyEntradaDados>
            </CardGridEntradaDados>
        </GridItem6sm12xs12>
    )
}

export default CadastroFormConjuge